// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jkI-R","imgSec":"styles_imgSec__3CiUO","img":"styles_img__ySax0","logo":"styles_logo__M-CBT","body":"styles_body__-Hmi6"};